import { proxy } from 'valtio';

/**
 * Whether this page already renders a Contentful-placed Recently Viewed
 * carousel, so the global section (BEC-24811) can stand down.
 *
 * A store, not context: the global section sits in the layout, an ancestor of
 * the content that must signal it. A count, not a boolean, so several can
 * unregister independently.
 */
export interface RecentlyViewedPresenceState {
  count: number;
}

export const recentlyViewedPresenceState = proxy<RecentlyViewedPresenceState>({
  count: 0,
});

export const recentlyViewedPresenceActions = {
  register: () => {
    recentlyViewedPresenceState.count += 1;
  },

  unregister: () => {
    recentlyViewedPresenceState.count = Math.max(
      0,
      recentlyViewedPresenceState.count - 1,
    );
  },

  /** Test helper. */
  reset: () => {
    recentlyViewedPresenceState.count = 0;
  },
};
